import React from 'react'

export default function DistopikDryWet() {
    return 'dry/wet'
}